/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum MiscContentType {
    Unknown = 0,
    PreliminaryStatement = 1,
    GeneralObjections = 2,
    DiscoveryQuestion = 3
}

export function MiscContentTypeFromJSON(json: any): MiscContentType {
    return MiscContentTypeFromJSONTyped(json, false);
}

export function MiscContentTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MiscContentType {
    return json as MiscContentType;
}

export function MiscContentTypeToJSON(value?: MiscContentType | null): any {
    return value as any;
}

